import React from 'react';
import './button.scss';

// Button component for rendering a custom button
const Button = ({ text, loader, onClick, className, disabled, style }) => {
  // Convert backgroundColor to background so it overrides the CSS gradient
  const buttonStyle = style?.backgroundColor
    ? { ...style, background: style.backgroundColor }
    : style;

  return (
    <div className={'button'} onClick={() => { !disabled && onClick && onClick() }}>
      <button className={className ? className : ""} disabled={disabled} style={buttonStyle}>
        {text}
        {loader && (
          <div className="loader"></div>
        )}
      </button>
    </div>
  );
}

export default Button;
